import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminRateMirrors,
  initializeRateAdminRateMirrorsScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminRateMirrors,
  deleteRateMirrorsAdminRateMirrors,
  saveRateMirrorsTableState,
} from "../../../redux/actions/RateAdmin/rateadminRateMirrors";
import RateAdminRateMirrors from '../../../component/RateAdmin/RateAdminRateMirrors';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
function RateAdminRateMirrorsScreen(props) {
  const {
    fetchRateAdminRateMirrors,
    initRateAdminRateMirrorsScreen,
    showPageLevelLoader,
    rateAdminRateMirrorsListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminRateMirrors,
    isRateAdminRateMirrorsExportError,
    isRateAdminRateMirrorsExportSuccess,
    isLoading,
    deleteRateMirrorsAdminRateMirrors,
    setDeleteConfirmationPopupVisibility,
    isRateAdminRateMirrorsDeleteSuccess,
    isRateAdminRateMirrorsDeleteError,
    shouldOpenDeleteConfirmationPopup,
    savedTableState,
    saveRateMirrorsTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId")
    };
  };

  useEffect(() => {
    initRateAdminRateMirrorsScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminRateMirrors(savedParams);
    } else {
      fetchRateAdminRateMirrors({ sortField: 'id', userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newPyload = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchRateAdminRateMirrors(newPyload);
  };

  const handleTableStateChange = (tableState) => {
    saveRateMirrorsTableState(tableState);
  };

  const handleCreateRateAdminRateMirrors = () => {
    navigate(APP_URLS.RATEADMIN_RATEMIRRORS.CREATE);
  }
  const editRateAdminRateMirrorsRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATEMIRRORS.EDIT, {
      id,
    });
    navigate(path);
  };
  const copyRateAdminRateMirrorsRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATEMIRRORS.COPY, {
      id,
    });
    navigate(path);
  };
  const rateAdminRateMirrors = {
    handleCreateRateAdminRateMirrors,
    deleteRateMirrorsAdminRateMirrors,
    isRateAdminRateMirrorsDeleteSuccess,
    isRateAdminRateMirrorsDeleteError,
    shouldOpenDeleteConfirmationPopup,
    exportRateAdminRateMirrors,
    isRateAdminRateMirrorsExportError,
    isRateAdminRateMirrorsExportSuccess,
    editRateAdminRateMirrorsRoute,
    copyRateAdminRateMirrorsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchRateAdminRateMirrorss: loadLazyData,
    tableData: {
      columns: rateAdminRateMirrorsListview?.columns,
      rows: rateAdminRateMirrorsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminRateMirrors
        {...rateAdminRateMirrors}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminRateMirrorsScreen: () => dispatch(initializeRateAdminRateMirrorsScreen()),
    fetchRateAdminRateMirrors: (payload) => dispatch(fetchRateAdminRateMirrors(payload)),
    deleteRateMirrorsAdminRateMirrors: (payload) => dispatch(deleteRateMirrorsAdminRateMirrors(payload)),
    exportRateAdminRateMirrors: (payload) => dispatch(exportRateAdminRateMirrors(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    saveRateMirrorsTableState: (payload) => dispatch(saveRateMirrorsTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminRateMirrorsCreateSuccess: selectFromRateAdminRateMirrorsReducer(
      state,
      "isRateAdminRateMirrorsCreateSuccess"
    ),
    rateAdminRateMirrorsListview: selectFromRateAdminRateMirrorsReducer(
      state,
      "rateAdminRateMirrorsListview"
    ),
    showPageLevelLoader: selectFromRateAdminRateMirrorsReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminRateMirrorsReducer(
      state,
      "paginationInfo"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromRateAdminRateMirrorsReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    isPageLevelError: selectFromRateAdminRateMirrorsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminRateMirrorsReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminRateMirrorsExportError: selectFromRateAdminRateMirrorsReducer(
      state,
      "isRateAdminRateMirrorsExportError"
    ),
    isRateAdminRateMirrorsDeleteSuccess: selectFromRateAdminRateMirrorsReducer(
      state,
      "isRateAdminRateMirrorsDeleteSuccess"
    ),
    isRateAdminRateMirrorsDeleteError: selectFromRateAdminRateMirrorsReducer(
      state,
      "isRateAdminRateMirrorsDeleteError"
    ),

    isRateAdminRateMirrorsExportSuccess: selectFromRateAdminRateMirrorsReducer(
      state,
      "isRateAdminRateMirrorsExportSuccess"
    ),
    savedTableState: selectFromRateAdminRateMirrorsReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminRateMirrorsReducer = (state, path) => {
  return selectRateAdminRateMirrorsReducer(state)[path];
};

const selectRateAdminRateMirrorsReducer = ({ rateadminRateMirrorsReducer }) => {
  return rateadminRateMirrorsReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RateAdminRateMirrorsScreen);
